var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { height: "calc(100vh - 160px)", "overflow-y": "auto" },
    },
    [
      _vm.customerType.type !== "examine"
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", float: "right" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-plus", plain: "", size: "small" },
                      on: { click: _vm.clickAddData },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.create")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-plus",
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          _vm.clickSenderDialog(
                            _vm.$t("customerManagements.createSender"),
                            null
                          )
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("navbar.orderImport")) + " ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "demo-ruleForm",
              attrs: {
                inline: false,
                model: _vm.newFormInline,
                "label-position": "top",
                size: "mini",
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.newFormInline.skuList,
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                    },
                    border: "",
                    height: "670",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.serial"),
                      type: "index",
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("uploadFile.skuSystemCode"),
                      "min-width": "120",
                      prop: "skuSystemCode",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { "min-width": "140", prop: "productName" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("span", { staticStyle: { color: "#f00" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("uploadFile.productName")) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flx-center" },
                              [
                                scope.row.isEdit === false
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.productName) +
                                          " "
                                      ),
                                    ])
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "skuList." +
                                            scope.$index +
                                            ".productName",
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t(
                                                "GlobalSetObj.pleaseInput"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: 500,
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseInput"
                                            ),
                                            clearable: "",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value: scope.row.productName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "productName",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.productName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { "min-width": "150", prop: "skuCode" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("span", { staticStyle: { color: "#f00" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("uploadFile.productSkuCode")) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flx-center" },
                              [
                                scope.row.isEdit === false
                                  ? _c("div", [
                                      _vm._v(
                                        " " + _vm._s(scope.row.skuCode) + " "
                                      ),
                                    ])
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "skuList." +
                                            scope.$index +
                                            ".skuCode",
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t(
                                                "GlobalSetObj.pleaseInput"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: 50,
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseInput"
                                            ),
                                            clearable: "",
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value: scope.row.skuCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "skuCode",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.skuCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { "min-width": "120", prop: "dimension" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("span", { staticStyle: { color: "#f00" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("uploadFile.appearanceDimensions")
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flx-center" },
                              [
                                scope.row.isEdit === false
                                  ? _c("div", [
                                      _vm._v(
                                        " " + _vm._s(scope.row.dimension) + " "
                                      ),
                                    ])
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "skuList." +
                                            scope.$index +
                                            ".dimension",
                                          rules: _vm.dimensionVeriy,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: 8,
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseInput"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value: scope.row.dimension,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "dimension",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.dimension",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { "min-width": "120", prop: "grossWeight" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("span", { staticStyle: { color: "#f00" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("uploadFile.grossWeight")) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flx-center" },
                              [
                                scope.row.isEdit === false
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.grossWeight) +
                                          " "
                                      ),
                                    ])
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "skuList." +
                                            scope.$index +
                                            ".grossWeight",
                                          rules: _vm.weightVeriy,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: 8,
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseInput"
                                            ),
                                            clearable: "",
                                          },
                                          model: {
                                            value: scope.row.grossWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "grossWeight",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.grossWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { "min-width": "120", prop: "status" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("span", { staticStyle: { color: "#f00" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("GlobalSetObj.status")) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flx-center" },
                              [
                                scope.row.isEdit === false
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.status
                                              ? _vm.$t("GlobalSetObj.enable")
                                              : _vm.$t("GlobalSetObj.stop")
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "skuList." +
                                            scope.$index +
                                            ".status",
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t(
                                                "GlobalSetObj.pleaseInput"
                                              ),
                                              trigger: ["change", "blur"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            model: {
                                              value: scope.row.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.status",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "GlobalSetObj.enable"
                                                ),
                                                value: 1,
                                              },
                                            }),
                                            _c("el-option", {
                                              attrs: {
                                                label:
                                                  _vm.$t("GlobalSetObj.stop"),
                                                value: 0,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.CreationTime"),
                      "min-width": "120",
                      prop: "createTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.CreatePeople"),
                      "min-width": "120",
                      prop: "createUserName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.LastModified"),
                      "min-width": "120",
                      prop: "updateTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.editor"),
                      "min-width": "120",
                      prop: "updateUserName",
                    },
                  }),
                  _vm.customerType.type !== "examine"
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.operate"),
                          align: "center",
                          fixed: "right",
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    scope.row.isEdit === false
                                      ? _c(
                                          "div",
                                          { staticClass: "flx-around" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icon-a-ziyuan37 editOperation",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editSku(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : scope.row.isDel === true
                                      ? _c(
                                          "div",
                                          { staticClass: "flx-around" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icon-a-ziyuan54 delOperation",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delSku(scope.row)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _c("div", [
                                          scope.row.isEditNew === false
                                            ? _c("span")
                                            : _c(
                                                "div",
                                                { staticClass: "flx-around" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "iconfont icon-chenggong cancalOperation",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.saveOneSku(
                                                          scope,
                                                          scope.row.id
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", {
                                                    staticClass:
                                                      "iconfont icon-a-ziyuan40 delOperation",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.cancelSku(
                                                          scope
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                        ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2002548801
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flx-end", staticStyle: { "margin-top": "15px" } },
            [
              _c("el-pagination", {
                staticStyle: { "margin-right": "15px" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.queryForm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
              _vm.customerType.type !== "examine"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.clickSubmit },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("uploadFile.submit")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", size: "small" },
                          on: { click: _vm.resetForm },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("customerManagements.reset")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("navbar.orderImport"),
            visible: _vm.exportDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialog = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "18px",
                  "margin-bottom": "10px",
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("uploadFile.uploadSkuInfoFile")) + " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "flx-center" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      "before-upload": _vm.beforeUpload,
                      "file-list": _vm.fileList,
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                      "http-request": _vm.handleHttpRequest,
                      limit: 1,
                      "on-remove": _vm.handleRemove,
                      accept: ".csv,.xlsx",
                      action: "#",
                      drag: "",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("uploadFile.dragOrClickToUpload"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "16px",
                  margin: "10px",
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("uploadFile.skuTemplateDownload")) + " "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "downModule flx-between",
                on: { click: _vm.downLoadFile },
              },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("orderCenterCont.DownloadTemplate"))),
                ]),
                _c("div", [_c("i", { staticClass: "el-icon-download" })]),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.cusSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.cusSubmit(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }